import { render, staticRenderFns } from "./NotificationLawyerDropDown.vue?vue&type=template&id=bf703866&"
import script from "./NotificationLawyerDropDown.vue?vue&type=script&lang=js&"
export * from "./NotificationLawyerDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports